import React, { useState } from 'react'
import { Modal, Button } from 'antd'
import Flex from 'components/Flex'
import FilterIcon from 'components/icons/FilterIcon'
import styled, { css } from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import { AiFillCaretDown } from 'react-icons/ai'

const FilterFlex = styled(Flex)`
  cursor: pointer;
  align-items: center;
`

const FilterText = styled.p`
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
`

const VerticalLine = styled.div`
  width: 1px;
  height: 38px;
  background-color: ${COLORS.GREY_T_90};
`

const StyledModal = styled(Modal)`
  .ant-modal-content {
    background-color: white !important;
    height: 55vh;
    margin-top: 150px !important;
    display: flex;
    flex-direction: column;
    padding: 0;
  }
  .ant-modal-body {
    padding: 0 !important;
  }
  .ant-modal-header {
    background-color: white !important;
    border-bottom: none !important;
    padding: 16px 24px;
    height: 5vh;
  }
  .ant-modal-title {
    font-weight: bold !important;
  }
  .ant-modal-footer {
    border-top: none !important;
  }
`

const ModalBody = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 50vh;
`

const OverlayMenuContainer = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
  gap: 16px;
`

const LeftPane = styled.div`
  width: 30%;
  overflow-y: auto;
  border: 1px solid #dddddd;
`

const RightPane = styled.div`
  width: 70%;
  overflow-y: auto;
  padding: 10px;
  position: relative;

  /* Add padding at the bottom equal or more than footer height */
  padding-bottom: 60px; 

  &::-webkit-scrollbar {
    display: none;
  }
`

const FooterButtonGroup = styled.div`
  position: absolute;
  bottom: 10px; /* padding inside right pane */
  right: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: white; /* optional: to keep button background solid */
  z-index: 10;
  /* add padding and border-radius if needed */
`


const ApplyButton = styled(Button)`
  border-radius: 8px;
`

const CancelButton = styled(Button)`
  color: blue;
  border-color: blue;
  border-radius: 8px;

  &:hover,
  &:focus {
    color: darkblue;
  }
`

const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const FilterBox = styled(Flex)`
  cursor: pointer;
  align-items: center;
  width: fit-content;
  padding: 0 10px;
  gap: 10px;
  justify-content: space-between;

  ${({ unsetRightBorder }) =>
    unsetRightBorder &&
    css`
      border-right: none;
    `}
`

const FilterItem = styled.div`
  padding: 10px;
  cursor: pointer;
  background-color: transparent;
  border-bottom: 1px solid #dddddd;
  font-weight: normal;
  font-size: 14px;

  &:hover {
    background-color: #f9f9f9;
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: #3249d7;
      border: 1px solid #3249d7;
      font-weight: 500;
    `}
`

const NewFilterDiv = ({
  width,
  overlayMenu = [],
  label = 'Filter',
  open = false,
  setOpen,
  onOpenChange,
  unsetRightBorder,
  DWidth,
  onApplyFilter,
  onCancelFilter,
  ...rest
}) => {
  const [selectedKey, setSelectedKey] = useState(overlayMenu?.[0]?.key)

  const handleCancel = () => setOpen(false)
  const handleOk = () => setOpen(false)
  const handleOpen = () => setOpen(true)

  const activeItem = overlayMenu?.find(item => item.key === selectedKey)
  const ActiveContent = activeItem?.children

  return (
    <>
      <FilterBox onClick={handleOpen} unsetRightBorder={unsetRightBorder}>
        <VerticalLine />
        <FilterFlex>
          <LeftContent>
            <FilterIcon />
            <FilterText>{label}</FilterText>
          </LeftContent>
          <AiFillCaretDown
            style={{ marginLeft: '50px', color: COLORS.GREY_T_90 }}
          />
        </FilterFlex>
        <VerticalLine style={{ marginLeft: '10px' }} />
      </FilterBox>

      <StyledModal
        title={label}
        open={open}
        onCancel={handleCancel}
        closable={false}
        footer={null}
        width={DWidth}
        maskClosable={false}
        {...rest}
      >
        <ModalBody>
          <OverlayMenuContainer>
            <LeftPane>
              {Array.isArray(overlayMenu) &&
                overlayMenu.map(item => (
                  <FilterItem
                    key={item.key}
                    isSelected={item.key === selectedKey}
                    onClick={() => setSelectedKey(item.key)}
                  >
                    {item.label}
                  </FilterItem>
                ))}
            </LeftPane>

            <RightPane>
              {React.isValidElement(ActiveContent) ? (
                ActiveContent
              ) : ActiveContent ? (
                <>{ActiveContent}</>
              ) : (
                <div>No content</div>
              )}
            </RightPane>
          </OverlayMenuContainer>
        </ModalBody>
        <FooterButtonGroup>
                <CancelButton size="large" onClick={onCancelFilter}>
                  Cancel
                </CancelButton>
                <ApplyButton type="primary" size="large" onClick={onApplyFilter}>
                  Apply Filter
                </ApplyButton>
              </FooterButtonGroup>
      </StyledModal>
    </>
  )
}

export default NewFilterDiv
